import { createStore } from 'effector';

export const $userViewInfo = createStore({});
$userViewInfo.watch((state) => console.log('$userViewInfo', state));
